import React from 'react';
import { Box, Card, CardActionArea, CardContent, Skeleton, Stack } from '@mui/material';
import LeadCardHeader from './LeadCardHeader';
import LeadInterest from './LeadInterest';
import LeadDepartmentChip from './LeadDepartmentChip';
import LeadStatusChip from './LeadStatusChip';
import useLeadCardPending from '../hooks/useLeadCardPending';
import { getLeadCardBorderColor } from '../utils/leadCardStyles';

// Card compacto do lead: header completo + interesse e departamento no
// conteúdo, sem status/atendido-por/campanha. A exceção é o pill "Aguardando
// atendimento" (alerta de SLA), urgente demais para ficar só no card completo. Independente de
// LeadCardNormal.js — alterar o layout aqui não afeta o card completo,
// embora ambos compartilhem o mesmo LeadCardHeader.
const LeadCardCollapsed = ({ lead, pendingAction }) => {
  const { isPending, fireAction, stop } = useLeadCardPending(pendingAction);

  return (
    <Card
      sx={(theme) => ({
        mb: 2,
        borderRadius: 3,
        borderTop: 4,
        borderTopColor: getLeadCardBorderColor(lead, theme),
        opacity: lead.readOnly ? 0.75 : 1,
      })}
    >
      <LeadCardHeader
        lead={lead}
        pendingAction={pendingAction}
        isPending={isPending}
        fireAction={fireAction}
        stop={stop}
      />

      {/* Área clicável → abre a conversa (chat ao vivo ou prévia). component="div"
          para não aninhar <button>. */}
      <CardActionArea component="div" onClick={lead.onOpenConversation}>
        <CardContent>
          <Stack spacing={1}>
            {lead.waitingForHuman && (
              <LeadStatusChip
                status={lead.status}
                waitingForHuman={lead.waitingForHuman}
                waitingForHumanSince={lead.waitingForHumanSince}
                fullWidth
              />
            )}

            <Stack direction="row" justifyContent="space-between" alignItems="center" spacing={1} flexWrap="wrap" useFlexGap>
              <Box sx={{ minWidth: 0, flexGrow: 1 }}>
                {!lead.hasInsight ? (
                  <Skeleton variant="text" width={120} />
                ) : (
                  <LeadInterest interest={lead.interest} />
                )}
              </Box>
              <LeadDepartmentChip department={lead.department} />
            </Stack>
          </Stack>
        </CardContent>
      </CardActionArea>
    </Card>
  );
};

export default LeadCardCollapsed;
